import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {useNavigate, useParams} from "react-router-dom";
import {CiCalendarDate, CiLocationOn} from "react-icons/ci";

const currencyFormat = Intl.NumberFormat('en-US');

function VendorOrders() {
    const navigate = useNavigate();
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [orders, setOrders] = React.useState([]);



    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            window.location.replace('/login')
        }
        const params = {
            count: 40,
            page: 1,
            list: 1,
            orderBy: 'created_at',
            orderType: 'desc',
            status_id : 3,
            vendor_id : id

        }

        API.getOrders(params)
            .then((response) => {
                setOrders(response.data);
                setIsLoaded(true)
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });

        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },400)

    }, [id]);




    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title='تاریخچه سفارش ها' hasBack={true} />

            <section className="container-fluid  mt-3 py-5 rtl px-0   ">




                <div className="row mx-2 mb-3">
                    {
                        orders.map (order => {
                            return (
                                <div className="col-12 rtl mb-2 order-row pb-2 "
                                     key={order.id}
                                     onClick={() => navigate(`/orders/${order.id}`)}
                                >
                                    <div className="row py-2 ">
                                        <div className="col-2 fw-bold text-small-1 text-muted border-bottom pb-3 ">
                                            <img src={order.vendor.image} alt={order.vendor.title}
                                            />
                                        </div>
                                        <div className="col-7 fw-bold text-small-1 text-muted border-bottom pb-3">
                                            {order.vendor.title}
                                            <span className='badge badge-info badge-pill bg-primary-color text-center mx-2 '>
                                        {
                                            order.totalScore
                                        }
                                    </span>
                                            <div className='fw-normal text-small-2 mt-2'>
                                                <CiLocationOn className='ms-1' />
                                                {order.address.title}
                                                :
                                                &nbsp;
                                                {order.address.address.substring(0, 30)}
                                            </div>

                                        </div>
                                        <div className="col-3 text-start border-bottom pb-3">
                                            <div className='text-small-2 bg-success bg-opacity-10 text-center rounded '>
                                                {order.tracking_code}
                                            </div>
                                            <div className=' mt-3 text-center rounded bg-secondary text-small-3  bg-opacity-10' style={{color: order.last_status.color}}>
                                                {order.last_status.title}
                                            </div>

                                        </div>
                                        <div className="col-6">
                                            <div className='fw-normal text-small-2 mt-2 text-muted'>
                                                <CiCalendarDate className='ms-1' />
                                                {order.date}
                                            </div>
                                        </div>
                                        <div className="col-6 text-start text-secondary mt-2 text-small-1 fw-bolder">
                                            {
                                                order.cash_discount_percent > 0 ?
                                                    currencyFormat.format(order.pay_amount * ( 1 - (order.cash_discount_percent / 100)))
                                                    :
                                                    currencyFormat.format(order.pay_amount)
                                            }

                                            &nbsp;
                                            ریال
                                        </div>
                                    </div>
                                </div>
                            )} )
                    }
                </div>

            </section>
            <Navbar />
        </React.Fragment>
    );
}

export default VendorOrders;